import React from 'react'
import { useNavigate } from 'react-router'
import { useDispatch } from 'react-redux'
import ConfirmModal from '../../modals/confirm-modal/ConfirmModal';
import EditUser from '../../modals/edit-user/EditUser';
import CreateUser from '../../modals/create-user/CreateUser';

const ModalContainer = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    
    return (
        <>
            <ConfirmModal />
            {/* <EditUser/> */}
            {/* <CreateUser/> */}
        </>
    )
}

export default ModalContainer